<script>
    import Modal from "./modal.svelte";

	import Youtube from "svelte-youtube-embed";
	let showModal = false;
</script>
		<div on:keypress on:click={() => (showModal = true)}>
			<img class="svgTop" src="/images/Ellipse.svg" alt="" />
                <img class="svgbottom" src="/images/Polygon.svg" alt="" />
		</div>

<Modal bind:showModal>
	<Youtube id="pm1_hOp5dos" animations={true} altThumb={true} />
</Modal>

<style>
	 .svgTop {
        position: relative;
        height: 80px;
        width: 80px;
    }
    .svgbottom {
        position: absolute;
        bottom: 15px;
        right: 10px;
        height: 50px;
        width: 50px;
    }
    .svgbottom:hover {
        bottom: 18px;
        transition: transform 0.35s ease-out;
    }
    .svgTop:hover {
        bottom: 2px;
        transition: transform 0.35s ease-out;
    }
</style>